<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-menu-button auto-hide="false" data-test="sidemenuButton"></ion-menu-button>
        </ion-buttons>
        <ion-title #title data-test="title">About</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)" data-test="moreButton">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<!-- </ion-list (keydown.alt.control.arrowup)="onExecuteAutoTypeClick($event, 'dealership')"> -->
<ion-content>
    <ion-list>
        <!-- @if (debugMode) {
  <ion-input (keydown.alt.control.arrowup)="onReset()" data-test="about"></ion-input>
} -->
        <ion-item-divider color="tertiary">
            General
        </ion-item-divider>

        <!-- [disabled]=vb.disabled -->
        <ion-item  detail="true" data-test="version" href="javascript:;"
            (click)="onVersionClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Version</span><br />
                <span class="line2">Properties of this application.</span>
            </ion-label>
        </ion-item>

        <ion-item [disabled]=vb.disabled detail="true" data-test="releaseNotes" href="javascript:;"
            (click)="onReleaseNotesClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Release Notes</span><br />
                <span class="line2">A detailed description of the latest changes.</span>
            </ion-label>
        </ion-item>

        <ion-item-divider color="tertiary">
            Legal
        </ion-item-divider>

        <ion-item [disabled]=vb.disabled detail="true" data-test="termsOfService" href="javascript:;"
            (click)="onTermsOfServiceClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Terms of Service</span><br />
                <span class="line2">Our agreement with you.</span>
            </ion-label>
        </ion-item>

        <ion-item [disabled]=vb.disabled detail="true" data-test="privacyPolicy" href="javascript:;"
            (click)="onPrivacyPolicyClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Privacy Policy</span><br />
                <span class="line2">Our legal promise to keep your data private and secure.</span>
            </ion-label>
        </ion-item>
    </ion-list>
</ion-content>
